import { gql } from '@apollo/client';

export const GET_MISSED_ATTENDANCE = gql`
query AttendanceMissed {
  attendanceMissed {
    id
    name
  }
}`;
